// import { Link } from 'react-router-dom'
// import VideoPlayer from '../VideoPlayer'
// import { MEDIA_URL } from '../../params'
import '../../assets/scss/WelecomeQuoteInline.scss'
import { Component } from 'react'
// import axios from 'axios'
// import Loader from '../Loader'

class WelecomeQuoteInline extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      loading_field_person_image: true,
      loading_field_quotes: true,
      achevements: [
        { value: '+350', name: 'Faculty & Researchers' },
        { value: '+56', name: 'Facilities' },
        { value: '+1435', name: 'Publications' },
        { value: '+36', name: 'Patents' },
      ],
      action: { text: 'VPR Biography', link: '/research/office-vpr/biography#vpr-office-bio' },
      title: props.title ? props.title : '',
      profile: '',
      about: '',
      writer_name: 'Dr. Richard O\'Kennedy',
      writer_position: 'Vice-President for Research',
      writer_avatar: '/uploads/Dr_Richard_profile.jpeg',
      writer: {
        signature: '/uploads/signature.png',
      },
      video: {
        poster: '/uploads/photo-2.jpg',
        src: '/uploads/welcome.mp4',
      },
      quote: "<p>“At Hamad Bin Khalifa University, we are committed to developing a competitive, relevant and impactful research portfolio to support Qatar in meeting its challenges and to enhance the lives of our local, national and global community. Our research is made possible by our excellent researchers, faculty staff and students working on complex issues from finding cure for cancer and creating innovative technologies to contributing to the cultural and social well-being to serve the public good. Our University prides itself with outstanding academic programs and world-class national research capabilities propelled by our six colleges and the three national research institutes to build future leaders, support Qatar’s knowledge-base economic growth and to transform our research into value creation for real-world impact.</p> <p>Since its inception in 2010, HBKU has continued to grow and strengthen its programs to now reach 20 interdisciplinary academic programs related to law, public policy, humanities and social sciences, health, Islamic studies and science and engineering and 15 R&amp;D programs in key areas such as energy, environment, water, biomedical, cyber security and social computing. </p> <p> We are proud of what we have achieved, our faculty staff and researchers are being recognized as innovators, thought leaders and entrepreneurs as demonstrated by their publications in leading journals, inventions, prestigious awards and success in external grants. We have established a portfolio of world-leading partners from academia and industry working with our University on key research areas. Our students are winning awards internationally for their research work and academic excellence. At the Office of the Vice President for Research (OVPR), we remain committed to cultivating excellence in research through innovation, interdisciplinary collaborations that extend beyond our institutional borders. We promote innovative research through idea sharing, pooling of resources, working collaboratively and providing excellent research support to scale our scholarly, research and creative works so our University can continue its trajectory of excellence and to ensure its success now and in the future. </p> <p> Whether you are a member of HBKU, a potential collaborator or a research sponsor, I invite you to explore our webpage and learn more about research in HBKU.</p>",
    }
  }

  refresh = () => {
    // this.setState(
    //   {
    //     loading: true,
    //     loading_field_person_image: true,
    //     loading_field_quotes: true,
    //   },
    //   () =>
    //     axios
    //       .get(this.props.url)
    //       .then(res => {
    //         const attributes = res.data.data.attributes
    //         const relationships = res.data.data.relationships
    //         const state = {
    //           profile: attributes.field_profile_designation,
    //           about: attributes.field_about.processed,
    //           writer_name: attributes.title,
    //           writer_position: attributes.field_profile_designation,
    //           writer: { signature: '/uploads/signature.png' },
    //           loading: false,
    //         }

    //         this.setState(state, () => {
    //           axios
    //             .get(relationships.field_person_image.links.related.href)
    //             .then(res => {
    //               this.setState({
    //                 loading_field_person_image: false,
    //                 writer_avatar: MEDIA_URL + res.data.data.attributes.uri.url,
    //               })
    //             })
    //             .catch(err => console.log(err))

    //           axios
    //             .get(relationships.field_quotes.links.related.href)
    //             .then(res =>
    //               this.setState({
    //                 loading_field_quotes: false,
    //                 quote: res.data.data[0].attributes.field_description.processed,
    //               })
    //             )
    //             .catch(err => console.log(err))
    //         })
    //       })
    //       .catch(err => console.log(err))
    // )
  }

  componentDidUpdate(prevProps) {
    if (prevProps.url !== this.props.url) this.refresh()
  }

  componentDidMount() {
    if (this.props.url) this.refresh()
  }

  render() {
    // const { loading, loading_field_person_image, loading_field_quotes } = this.state
    //if (loading || loading_field_person_image || loading_field_quotes) return <Loader />
    const { lang } = this.props
    return (
      <section
        id={this.props.itemId}
        dir={lang === 'ar' ? 'rtl' : 'ltr'}
        className='welecome-quote-inline m-wrap d-none'>
        <div className='container'>
          <h2>{this.state.title}</h2>
          <div className='row'>
            <div className='col-12 col-lg-12'>
              <q
                dir={lang === 'ar' ? 'rtl' : 'ltr'}>
                  {/* <VideoPlayer height='500px' {...this.state.video} />  aria-hidden="true" */}
                  <img className='video-player' src={this.state.video.poster} alt='Colleges' />
                 <p>At Hamad Bin Khalifa University (HBKU), we are committed to developing a competitive, relevant, and impactful research portfolio to support Qatar in addressing its challenges, achieving its national vision, and enhancing the lives of our local, national, and global communities.  Our research is made possible by our excellent students, faculty, researchers, technologists, and staff working together across a broad spectrum of academic and applied research areas.</p>
                 <p>Our university takes pride in its outstanding academic programs and world-class research facilities, driven by our six colleges and three national research institutes to build future leaders, support Qatar’s sustainable and diversified economic growth, and transform our research to generate value as well as real-world impact.</p>
                 <p>Since its inception in 2010, HBKU has continued to grow and strengthen its programs. It now has many interdisciplinary academic programs related to law, public policy, humanities and social sciences, health, Islamic studies, and science and engineering. It also has multiple research and development programs in areas such as artificial intelligence, energy, the environment, water management, precision medicine, cyber security, law, humanities and social sciences, innovation, policy development, and social computing.</p>
                 <p>We are proud of what we have achieved - our students, faculty, researchers, and technologists are being recognized as innovators, thought leaders, and entrepreneurs, as demonstrated by their publications in leading journals, inventions, patents, prestigious awards for research and academic excellence, success in securing external grants, and extensive local and international collaborations with world-leading entities and organizations.</p>
                 <p>At the OVPR, we remain committed to furthering this excellence in research through innovation and interdisciplinary collaborations that extend beyond our institutional borders. We promote innovative research through knowledge sharing, pooling of resources, working collaboratively, and providing excellent research support to scale our scholarly research and creative works, so that our university can continue on a trajectory of excellence and thereby ensuring its success for the future. </p>
                 <p>Whether you are a member of HBKU, a potential collaborator, or a research sponsor, I invite you to explore our webpage and learn more about research at HBKU.</p>
                 </q>
            </div>
           
          </div>

          <div className='row'>
            <div className='col-12 col-xl-6  mt-5 mt-xl-0'>
              <div className='author'>
                
                <div className='avatar-badge'>
                  <img src={this.state.writer_avatar} alt={this.state.writer.name} />
                  <div className='avatar-badge-description'>
                    <span className='avatar-badge-description-name'>{this.state.writer_name}</span>
                    <span className='avatar-badge-description-position'>
                      {this.state.writer_position}
                    </span>
                  </div>
                </div>
                {/* <img
                  className='author-signature'
                  src={this.state.writer.signature}
                  alt={this.state.writer_name}
                /> */}
              </div>
              <a href={this.state.action.link}  className='action'>
                {this.state.action.text}
              </a>
            </div>

            {/* <div className='col-12 col-xl-6 welcome-achevements mt-5 mt-xl-0'>
              {this.state.achevements.map((e, k) => (
                <div className='welcome-achevements-item' key={k}>
                  <div className='welcome-achevements-item-value'>{e.value}</div>
                  <div className='welcome-achevements-item-name'>{e.name}</div>
                </div>
              ))}
            </div> */}
          </div>
        </div>
      </section>
    )
  }
}

export default WelecomeQuoteInline
